import { EventResponseType, EventType } from '../../types/event-types';
import {
	EventDto,
	EventInstanceDto,
	EventInstanceWithUserAttendanceDto,
	getEventEndDate,
	getMainEventFitnessType
} from '@sweatpals/shared';
import { last, map, size, slice, toNumber } from 'lodash-es';

export class EventsDto {
	public static buildDataFromResponse(data: EventInstanceWithUserAttendanceDto[], limit?: number): EventResponseType {
		const sliced: any = slice(data, 0, limit && limit - 1);
		const build = map(sliced, (d) => ({
			...d,
			avatarId: d?.author?.avatarId ?? null,
			startDate: d.instance ?? d.startDate,
			endDate: getEventEndDate(d)?.toISOString() as any,
			background: d?.avatarId,
			fitnessTypeIconId: d?.fitnessType?.iconId || null,
			fitnessTypeName: d?.fitnessType?.name || '',
			fitnessTypeIconPriority: d?.fitnessType?.hasPriorityOverNativeAsset ?? null,
		}));

		const totalCount = size(data);

		return {
			totalCount,
			hasMore: totalCount > limit - 1,
			data: build,
			lastEventId: last(build)?.id || '',
		};
	}

	public static buildExtendDataFromResponse(
		data: EventInstanceWithUserAttendanceDto[],
		limit?: number
	): EventResponseType {
		const build = map(data, (d) => ({
			...d,
			avatarId: d?.author?.avatarId ?? null,
			background: d?.avatarId,
			startDate: d.instance ?? d.startDate,
			endDate: getEventEndDate(d)?.toISOString() as any,
			iconId: d.fitnessTypeId,
			hostName: d.author?.fullName ?? null,
			masteryLevel: toNumber(d.masteryLevel) || null,
			fitnessTypeIconId: d?.fitnessType?.iconId || null,
			fitnessTypeName: d?.fitnessType?.name || '',
			fitnessTypeIconPriority: d?.fitnessType?.hasPriorityOverNativeAsset ?? null,
		})).slice(0, limit);

		const totalCount = size(data);

		return {
			totalCount,
			hasMore: totalCount > limit,
			data: build,
			lastEventId: last(build)?.id || '',
		};
	}

	public static buildSingleEvent(data: EventDto | EventInstanceDto): EventType {
		const mainFitnessType = getMainEventFitnessType(data?.fitnessTypes);

		return {
			...data,
			background: data?.avatarId,
			startDate: (data as EventInstanceDto)?.instance ?? data.startDate,
			endDate: getEventEndDate(data as EventInstanceDto)?.toISOString() as any,
			hostName: data?.author?.fullName ?? null,
			avatarId: data?.author?.avatarId ?? null,

			iconId: mainFitnessType?.fitnessTypeId || null,
			masteryLevel: toNumber(mainFitnessType?.masteryLevel) || null,
			fitnessTypeIconId: mainFitnessType?.interest?.iconId || null,
			fitnessTypeName: mainFitnessType?.interest?.name || '',
			fitnessTypeIconPriority: mainFitnessType?.interest?.hasPriorityOverNativeAsset ?? null,
		};
	}
}
